import React, { useState, useEffect } from 'react';
import './Dropdown.css';

export const Dropdown = ({ options = [], onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(options.length ? options[0] : { text: '' });

  useEffect(() => {
    if (selectedItem) onSelect(selectedItem);
  }, [selectedItem, onSelect]);

  return (
    <div className="dropdownContainer" data-testid="dropdownContainer">
      <div className="dropdown">
        <button type="button" className={`button ${isOpen && 'open'}`} onClick={() => setIsOpen(!isOpen)}>
          <span className="text">{selectedItem.text}</span>
          <img
            className={`chevron ${isOpen && 'open'}`}
            alt="chevron"
            width="24"
            height="24"
            src="/account/static/images/chevron.svg"
          />
        </button>
        <ul className={`list ${isOpen && 'open'}`}>
          {options.map((item) => (
            <li key={item.text}>
              <button
                className="item"
                onClick={() => {
                  setIsOpen(!isOpen);
                  setSelectedItem(item);
                }}
                aria-label={item.text}
              >
                {item.text}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
